import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5776e34c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-download-view-wrapper reports-menu-root" }
const _hoisted_2 = { class: "date-download-view" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-border" }, null, -1))
const _hoisted_4 = { class: "date-download-view-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "対象月 / データ選択", -1))
const _hoisted_6 = { class: "calendar-controller" }
const _hoisted_7 = { class: "date" }

import { computed, ref } from 'vue'
import DatePicker from '@/components/common/DatePicker.vue'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const initDataStore = useInitDataStore()
const date = ref<Date>(new Date())
const csvReports = computed(() => {
  return initDataStore.initData.csvReports
})
const targetTitle = ref<string>(initDataStore.initData.csvReports[0].title)
const targetReport = computed(() => {
  return csvReports.value.find(r => r.title === targetTitle.value)
})
const options = computed(() => {
  return csvReports.value.map(r => ({ label: r.title, value: r.title }))
})
const download = () => {
  const url = targetReport.value?.url(date.value)

  if (url === undefined) {
    return
  }

  window.open(url, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_UdcSelect = _resolveComponent("UdcSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_UdcSelect, {
          modelValue: targetTitle.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((targetTitle).value = $event)),
          options: _unref(options),
          defaultLabel: targetTitle.value,
          class: "no-border bg-gray"
        }, null, 8, ["modelValue", "options", "defaultLabel"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(DatePicker, {
              modelValue: date.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
              resolution: _unref(targetReport)?.range
            }, null, 8, ["modelValue", "resolution"])
          ])
        ]),
        _createElementVNode("button", {
          onClick: download,
          class: "btn-submit"
        }, "ダウンロード")
      ])
    ])
  ]))
}
}

})